<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#f5a335">
      <path d="m38.47 42.86c1.1-1.9 3.27-.52 4.65 2.2s3.39 9.18.49 11.16-4.37-2.22-5.41-5.08-1.41-5.39.27-8.28z" />
      <path
        d="m29 81.62c1.71-4.49 4.5-9 8.6-11.62 2.81-1.83.19-6.38-2.65-4.53-5.32 3.46-8.78 8.92-11 14.76-1.2 3.15 3.86 4.52 5.06 1.39z"
      />
      <path d="m54.56 30.34c1.46-1.65 3.31.13 4.11 3.08s1.49 9.68-1.76 11-3.82-3.08-4.27-6.07-.31-5.52 1.92-8.01z" />
      <path d="m46.06 36.7c1.3-1.77 3.31-.17 4.39 2.68s2.4 9.49-.7 11.15-4.1-2.7-4.83-5.63-.83-5.5 1.14-8.2z" />
      <path d="m71.68 31.83c2.2.18 1.89 2.73 0 5.14s-6.82 7-9.86 5.25.15-4.9 2.26-7.06 4.27-3.6 7.6-3.33z" />
      <path d="m72.63 49.67c1.86-1.18.4-3.29-2.37-4.56s-9.32-3-11.18 0 2.42 4.28 5.29 5.2 5.44 1.15 8.26-.64z" />
      <path d="m65.92 56.24c1.87-1.18.41-3.29-2.37-4.56s-9.31-3-11.18 0 2.42 4.27 5.3 5.2 5.43 1.12 8.25-.64z" />
      <path d="m59.75 63.05c1.87-1.18.41-3.29-2.37-4.56s-9.31-3-11.18-.05 2.42 4.27 5.3 5.2 5.43 1.2 8.25-.59z" />
      <path d="m31.74 51.29c1.1-1.9 3.27-.52 4.65 2.2s3.39 9.18.49 11.16-4.37-2.25-5.41-5.08-1.41-5.39.27-8.28z" />
      <path d="m53.27 68.82c1.86-1.18.4-3.3-2.38-4.56s-9.31-3-11.17-.05 2.42 4.27 5.29 5.2 5.44 1.2 8.26-.59z" />
    </g>
    <path
      d="m48 15.84a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09zm25.9 60.16a1.71 1.71 0 0 1 -.11-.14l-10-10.15c-2.18-2.21-5.57 1.23-3.39 3.44l10 10.15.14.12a34.06 34.06 0 0 1 -48-48.19l10.71 10.69c2.17 2.16 5.54-1.19 3.37-3.36l-10.62-10.56a34.06 34.06 0 0 1 47.9 48z"
      fill="#4f2b1b"
    />
  </svg>
</template>
